// Before ./styles.css so the app's own rules can override the library defaults.
import '@lemoncloud/page-transition-core/styles.css';
import './styles.css';

import { StrictMode } from 'react';

import { i18n } from '@muzly/shared/i18n';
import * as ReactDOM from 'react-dom/client';


import { App } from './app/app';
import { applyNativeSafeArea, syncDocumentLanguage } from './app/core';

applyNativeSafeArea(window.__MUZLY_DEVICE_INFO__);
syncDocumentLanguage(i18n);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
